var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary-title":""}},[_c('span',{staticClass:"title"},[_vm._v("Edit Source")])]),_c('v-card-text',[_c('Source',{attrs:{"id":_vm.$route.params.id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }